import * as React from "react";
import { useMemo } from "react";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import useEventBulkActions from "components/events/events/hooks/useEventBulkActions";
import useSecurityEventBulkActions from "security-app/components/SecurityEvents/Alerts/useSecurityEventBulkActions";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
import usePermissions from "hooks/usePermissions";
import useReplayBulkAction from "components/events/events/hooks/useReplayBulkAction";
const BulkActions = ({ selectedEntitiesData }) => {
  const { isPermitted } = usePermissions();
  const selectedEvents = useMemo(() => Object.values(selectedEntitiesData), [selectedEntitiesData]);
  const { actions, pluggableActionModals } = useEventBulkActions(selectedEvents);
  const { actions: securityEventActions, pluggableActionModals: securityEventModals } = useSecurityEventBulkActions(selectedEvents);
  const replayableEvents = selectedEvents.filter(
    (event) => !!event.replay_info && isPermitted(`eventdefinitions:read:${event.event_definition_id}`)
  );
  const onReplaySearchClick = useReplayBulkAction(replayableEvents);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkActionsDropdown, null, replayableEvents.length > 0 && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onReplaySearchClick }, "Replay Search"), actions, securityEventActions), pluggableActionModals, securityEventModals);
};
export default BulkActions;
